export default "__VITE_ASSET__DJmmXhna__"